module.exports = __webpack_public_path__ + "static/assets/8367039032cfd3682ce830aa38dd62ba.png";